// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--a2fe4";
export var footerAcknowledgment = "footer-module--footerAcknowledgment--5a3cb";
export var footerBMW = "footer-module--footerBMW--c2ee2";
export var footerBelowMargin = "footer-module--footerBelowMargin--c9e6f";
export var footerColumn = "footer-module--footerColumn--d6d39";
export var footerContainer = "footer-module--footerContainer--494c4";
export var footerCredit = "footer-module--footerCredit--0867b";
export var footerLeft = "footer-module--footerLeft--dd36e";
export var footerLinkContainer = "footer-module--footerLinkContainer--53f0d";
export var footerLogo = "footer-module--footerLogo--e0013";
export var footerUpper = "footer-module--footerUpper--8f540";